var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPassShowIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B8085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M1.333 8s2-4.667 6.667-4.667S14.667 8 14.667 8s-2 4.667-6.667 4.667S1.333 8 1.333 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7B8085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPassShowIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pass-show-icon.e58c04441c61e7d34569a59107d3161a.svg";